import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  min-height: 692px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 0;
  overflow: hidden;
  background: linear-gradient(
    108deg,
    rgba( 11, 31, 58, 1) 0%,
    rgba( 26, 47, 74, 1) 100%
  );
`
export const FormWrap = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 480px) {
    height: 80%;
  }
`
export const Icon = styled(Link)`
  margin-left: 32px;
  margin-top: 64px;
  text-decoration: none;
  color: #fff;
  font-weight: bold;
  font-size: 32px;
  display: flex;
  align-items: center;
  gap: 8px;

  @media screen and (max-width: 480px) {
    margin-left: 16px;
    margin-top: 64px;
  }
`
export const FormContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 480px) {
    margin-top: 30px;
    padding: 10px;
  }
`
export const Form = styled.form`
  background-color: white;
  max-width: 400px;
  height: auto;
  width: 100%;
  z-index: 1;
  display: grid;
  margin: 0 auto;
  padding: 60px 32px;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  @media screen and (max-width: 480px) {
    padding: 32px 24px;
  }
  `
export const FormH1 = styled.h1`
  margin-bottom: 32px;
  color: #0B1F3A;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  font-family: 'Inter', sans-serif;
`
export const FormLabel = styled.label`
  margin-bottom: 8px;
  font-size: 14px;
  color: #334155;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
`
export const FormInput = styled.input`
  padding: 16px 16px;
  margin-bottom: 24px;
  border-radius: 8px;
  border: 2px solid #e2e8f0;
  font-size: 16px;
  font-family: 'Inter', sans-serif;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #0B1F3A;
    box-shadow: 0 0 0 3px rgba(11, 31, 58, 0.1);
  }
`
export const FormButton = styled.button`
  background: #0B1F3A;
  padding: 16px 0;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  transition: all 0.2s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background: #1A2F4A;
    transform: translateY(-1px);
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
  }
`
export const Text = styled.span`
text-align: center;
margin-top: 24px;
color: #64748B;
font-size: 14px;
display: block;
text-decoration: none;
font-family: 'Inter', sans-serif;

&:hover {
  color: #0B1F3A;
}
`
